import { useMemo } from "react";
import { useRole } from "@/data/RoleContext";
import {
  getFinancialPermissions,
  isCrewRole,
  hasFullFinancialAccess,
  getFinancialLabel,
  type FinancialPermissions,
} from "@/data/financialPermissions";

/**
 * Hook that provides financial visibility permissions for the current role.
 * Use this in any component that displays financial data.
 */
export function useFinancialPermissions() {
  const { role } = useRole();

  return useMemo(() => {
    const permissions = getFinancialPermissions(role);
    return {
      ...permissions,
      isCrew: isCrewRole(role),
      isFullAccess: hasFullFinancialAccess(role),
      role,
      /** Get role-appropriate label for financial term */
      label: (term: string) => getFinancialLabel(term, role),
    };
  }, [role]);
}
